import { useState, useCallback } from 'react'

export default function useBooleanState() {
  const [state, setState] = useState<boolean>(false)

  const toggleState = useCallback(() => {
    setState(!state)
  }, [state])

  const closeState = useCallback(() => {
    setState(false)
  }, [])

  const openState = useCallback(() => {
    setState(true)
  }, [])

  return {
    state,
    toggleState,
    closeState,
    openState,
    setState,
  }
}
